import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";
import "../styles/global.css";
import { Terminal } from "xterm";
import { FitAddon } from "xterm-addon-fit";
import "xterm/css/xterm.css";
import { OPERATIONS_SERVICE_URL } from "../utils/constants";

function getWsBase() {
  // Use operations-service URL for WebSocket connections
  const opsServiceUrl = OPERATIONS_SERVICE_URL;

  // Convert http/https to ws/wss
  if (opsServiceUrl.startsWith("https://")) {
    return opsServiceUrl.replace(/^https:/, "wss:");
  } else if (opsServiceUrl.startsWith("http://")) {
    return opsServiceUrl.replace(/^http:/, "ws:");
  }

  // Fallback: use current host
  const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${window.location.host}`;
}

let wsRef = null;
let resizeHandler = null;

const Console = () => {
  const { id } = useParams(); // this is now DO droplet_id
  const [error, setError] = useState("");
  const originalTitle = useRef(document.title);

  useEffect(() => {
    return () => {
      document.title = originalTitle.current;
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/droplets/resolve/${id}`);
        const internalId = res.data.id;
        const displayName =
          res.data?.name ||
          res.data?.label ||
          res.data?.dropletName ||
          res.data?.hostname ||
          `Droplet ${res.data?.id || id}`;
        document.title = `${displayName} - Cyberin Web Console`;
        const { data } = await api.post(`/actions/${internalId}/console-token`);
        const token = data.token;
        initTerminal(token, internalId);
      } catch (e) {
        setError(e.response?.data?.message || "Unable to open console");
        document.title = `Cyberin Web Console`;
      }
    })();
    return () => {
      if (wsRef)
        try {
          wsRef.close();
        } catch (_) {}
      if (resizeHandler) window.removeEventListener("resize", resizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  function initTerminal(token, dropletId) {
    const termEl = document.getElementById("cterm");
    // Clean any previous terminal DOM
    termEl.innerHTML = "";
    if (wsRef) {
      try {
        wsRef.close();
      } catch (_) {}
      wsRef = null;
    }

    const term = new Terminal({
      cursorBlink: true,
      fontSize: 14,
      convertEol: true,
      scrollback: 2000,
    });
    const fit = new FitAddon();
    term.loadAddon(fit);
    term.open(termEl);
    fit.fit();
    term.focus();
    term.write("Connecting…\r\n");

    resizeHandler = () => fit.fit();
    window.addEventListener("resize", resizeHandler);

    // Connect to operations-service WebSocket
    const wsUrl = `${getWsBase()}/ws/console?token=${encodeURIComponent(
      token
    )}&dropletId=${dropletId}`;
    console.log("Connecting to WebSocket:", wsUrl);
    const ws = new WebSocket(wsUrl);
    ws.binaryType = "arraybuffer";
    ws.onopen = () => {
      term.reset();
    }; // clear "Connecting…" and reset scrollback
    ws.onmessage = (e) => {
      if (e.data instanceof ArrayBuffer) term.write(new Uint8Array(e.data));
      else term.write(e.data);
    };
    ws.onclose = () => term.write("\r\nConnection closed.\r\n");
    ws.onerror = () => term.write("\r\nConnection error.\r\n");
    term.onData((d) => ws.readyState === 1 && ws.send(d));

    wsRef = ws;
  }

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        background: "#0b0b0c",
        display: "grid",
        padding: "15px",
        overflowX: "hidden",
        overflowY: "auto",
      }}
    >
      <div
        id="cwrap"
        style={{
          width: "100vw",
          height: "95vh",
          overflow: "hidden",
          background: "#0b0b0c",
        }}
      >
        {error && (
          <div
            style={{
              position: "absolute",
              top: 8,
              left: 8,
              color: "#ef4444",
              fontSize: 12,
            }}
          >
            {error}
          </div>
        )}
        <div id="cterm" style={{ width: "100%", height: "100%" }} />
      </div>
    </div>
  );
};

export default Console;
